// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyC2vqexr-bs2CVlK5nImF4_dm3f23ZECjM",
  authDomain: "capstone-method-cards.firebaseapp.com",
  projectId: "capstone-method-cards",
  storageBucket: "capstone-method-cards.appspot.com",
  messagingSenderId: "754796397339",
  appId: "1:754796397339:web:fe12e02f7419ab2e6349be",
  measurementId: "G-PKXF45Q0GJ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);